"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Verified = void 0;
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Verified({ size = 15, color = '#3DB384', styles }) {
    return (React.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 30 35", fill: color, style: styles },
        React.createElement(react_native_svg_1.G, { id: "05-Apotheke-w\u00E4hlen", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement(react_native_svg_1.G, { id: "verified-icon", fill: color },
                React.createElement(react_native_svg_1.Path, { d: "M15,0 L30,6.3760957 L30,15.9383532 C30,24.7549935 23.5819715,32.9970182 15,35 C6.41802847,32.9970182 0,24.7474493 0,15.9383532 L0,15.9383532 L0,6.3760957 L15,0 Z M22.6476003,10 L11.6627219,20.4947174 L7.35239974,16.3717927 L5,18.6206607 L11.6692965,25 L25,12.248868 L22.6476003,10 Z", id: "Combined-Shape" })))));
}
exports.Verified = Verified;
